import injectSheet from 'react-jss'
import BtnLink from '@/components/BtnLink'
import ParallaxImg from '@/components/ParallaxImg'
import style from './style'

const SingleCard = ({
  classes,
  img,
  label,
  link,
  title,
  list,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.card}>
          <div className={classes.cardImage}>
            {img && (
              <ParallaxImg
                img={img}
                title={title}
              />
            )}
          </div>
          <div className={classes.cardInfo}>
            <div
              className={classes.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className={classes.list}>
              {list.map((li, i) => (
                <div
                  className={classes.itemList}
                  key={i.toString()}
                >
                  <span className={classes.itemListDot}><span /></span>
                  <div className={classes.itemListContent}>
                    <div
                      className={classes.title}
                      dangerouslySetInnerHTML={{ __html: li.title }}
                    />
                    <div
                      className={classes.text}
                      dangerouslySetInnerHTML={{ __html: li.text }}
                    />
                  </div>
                </div>
              ))}
            </div>
            {link && (
              <BtnLink
                link={link}
                label={label}
                theme="orange"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(SingleCard)
